// https://confluence.vk.team/pages/viewpage.action?pageId=1560502237

const BITMASK_FLAGS = [
    // 0. Есть право на чтение
    'READ_FLAG',
    // 1. Есть право на скачивание
    'DOWNLOAD_FLAG',
    // 2. Есть право на редактирование
    'EDIT_FLAG',
    // 3. Есть право на создание
    'CREATE_FLAG',
    // 4. Есть право на удаление
    'DELETE_FLAG',
    // 5. Есть право на шэринг
    'SHARE_FLAG',
] as const;

const isBitSet = (mask: number, bitIndex: number): boolean => (mask & (1 << bitIndex)) > 0;

export type DomainFolderBitmaskParams = Record<(typeof BITMASK_FLAGS)[number], boolean>;

export const getDomainFoldersBitmaskParams = (bitMask = 0): DomainFolderBitmaskParams => {
    return BITMASK_FLAGS.reduce((result, bit, index) => ({ ...result, [bit]: isBitSet(bitMask, index) }), {} as DomainFolderBitmaskParams);
};
